import type { FC } from 'react';
import { useCallback } from 'react';

import Button from '@trend-dev/trendtech-ui/components/UI/Button';

import { useTimerStore } from 'store/timer';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';

import { acceptText, cancelText } from '../const';

const Controls: FC = () => {
    const { prolongConference, setNotification } = useTimerStore();
    const { triggerYM } = useYM();

    const handleDecline = useCallback(() => {
        triggerYM({ goal: GoalType.CONFERENCE_PAGE_EXTEND_CLOSE });
        setNotification(null);
    }, [setNotification]);

    const handleAccept = useCallback(() => {
        triggerYM({ goal: GoalType.CONFERENCE_PAGE_EXTEND_ACCEPT });
        prolongConference();
        setNotification(null);
    }, [setNotification, prolongConference]);

    return (
        <>
            <Button key='0' onClick={handleDecline}>
                {cancelText}
            </Button>
            <Button key='1' kind='main' onClick={handleAccept}>
                {acceptText}
            </Button>
        </>
    );
};

export default Controls;
